import { trackEvent } from '@/segment/segment';
import { EventName, PageName } from '@/shared/types/segment';

/**
 * Typed Segment helpers for the analytics pages. Centralizing them keeps the
 * event names and the `page` property shape consistent across Overview, AI
 * Agents, Human Agents and Reports, so the adoption/usage queries can group on
 * a single key without per-page joins. `slug` is appended by `trackEvent`.
 */

/** Fires when the user commits a filter change (dropdown apply, saved view, or date range). */
export const trackAnalyticsFilterApplied = (
  page: PageName,
  filterType?: string,
  filterValue?: string
) =>
  trackEvent(EventName.ApplyAnalyticsFilter, {
    page,
    ...(filterType ? { filter_type: filterType } : {}),
    ...(filterValue ? { filter_value: filterValue } : {}),
  });

/** Fires when the user runs an export, tagged with the page it was triggered from. */
export const trackAnalyticsExport = (page: PageName, title: string, format: string) =>
  trackEvent(EventName.RunAnalyticsExport, { title, type: format, page });

/** Fires on every compare-mode toggle, carrying the resulting on/off state. */
export const trackAnalyticsCompareToggled = (page: PageName, enabled: boolean) =>
  trackEvent(EventName.ToggleAnalyticsCompare, { page, enabled });

/** Fires once a report is successfully created (the adoption signal). */
export const trackAnalyticsReportCreated = (page: PageName, reportId: string) =>
  trackEvent(EventName.ClickCreateReport, { page, report_id: reportId });
